import RedirectPage from '@common/components/redirect/redirectPage';

const redirect = [
  {
    path: '/',
    name: 'Redirect',
    component: RedirectPage,
  },
];

export default redirect;
